import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { UserComponent } from 'react/UserComponent';
import MessageParser from "../../components/MessageParser";
import withDefaultProps from 'functions/withDefaultProps';

export default function AutolinkedTextComponent(incomingProps) {
	const props = withDefaultProps(incomingProps, autolinkedTextDefaultProps);
	const { messageParser, linkText, text, options, renderLink, tagName, authoredByMe, linkedRooms, ...childProps } = props;

	const parser = useRef(props.messageParser);
	const [stateUpdateValue, stateUpdated] = useState(0);

	const propsSerialized = Object.values(props).map(function(value) {
		return value;
	});

	useEffect(() => {
		if(!parser.current) {
			parser.current = new MessageParser();
		}
		parser.current.updateProps(props);
		stateUpdated((previousValue) => previousValue + 1);
	}, [...propsSerialized, parser.current]);

	return React.createElement(tagName, childProps, parser.current ? parser.current.children : null);
}
AutolinkedTextComponent.propTypes = {
	options: PropTypes.object,
	renderLink: PropTypes.func,
	tagName: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.elementType,
	])
};
export const autolinkedTextDefaultProps = {
	messageParser: null,
	text: '',
	options: {},
	linkText: true,
	renderLink: (tag) => {
		if(tag.player) {
			return (
				<UserComponent
					user={tag.player}
					showModGavel={false}
					showDisplayName={true}
					key={tag.attrs.key}
					showAt={true}
					showBanned
				/>
			);
		}
		return React.createElement(tag.tagName, tag.attrs, tag.innerHtml);
	},
	tagName: React.Fragment
};